<template>
  <footer class="app-footer">
    <b-modal ref="version" id="version" :title="getTitle()" hide-footer>
      <h5>[NEW!] Stable 1.0.8</h5>
      <ul>
        <li>Now can show, create, edit and remove items in menu product</li>
        <li>Change dashboard layouts</li>
        <li>Fix dashboard issues</li>
      </ul>
      <h5>Stable 1.0.6</h5>
      <ul>
        <li>Insert category</li>
      </ul>
      <h5>Stable 1.0.5</h5>
      <ul>
        <li>Dashboard export excel as table</li>
        <li>Using toastr and more exciting UI</li>
      </ul>
      <h5>Release 1.0.0</h5>
      <ul>
        <li>Our new <a @dblclick="gotoConsole">admin page</a></li>
      </ul>
      <ul></ul>
    </b-modal>
    <span><a href="http://kopiketjil.com">Kopi Ketjil</a> &copy; 2018 CoreUI creativeLabs.</span>
    <span class="ml-auto">Powered by <a href="">Bluejack 16-1</a>. Version <a href="#" v-b-modal.version>{{ currentVersion }}</a></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer',
  data () {
    return {
      currentVersion: '1.0.8',
      title: 'Checkout our New Release!'
    }
  },
  methods: {
    getTitle () {
      return this.title
    },
    gotoConsole () {
      this.$router.push('/console')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue